import { jsx as _jsx } from "react/jsx-runtime";
const Logo = ({ className = '', style = {}, width = 24, height = 24 }) => {
    // Sharp upward arrow logo with elongated points
    return (_jsx("svg", { className: `sharpshot-logo ${className}`, width: width, height: height, viewBox: "0 0 100 100", style: style, xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M50 5 L95 95 L70 70 L50 50 L30 70 L5 95 Z", fill: "currentColor" }) }));
};
// Alternative image-based logo component (if you save the logo as an image file)
export const LogoImage = ({ className = '', style = {}, width = 24, height = 24 }) => {
    return (_jsx("img", { src: "/logo.svg", alt: "SharpShot Logo", className: `sharpshot-logo ${className}`, width: width, height: height, style: style }));
};
export default Logo;
